import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

const DeleteInventoryDialog = ({
  open,
  onClose,
  onDelete,
  count,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        Delete Inventory
      </DialogTitle>

      <DialogContent>

        <Typography>

          Are you sure you want to delete

          <b> {count} </b>

          selected inventory record
          {count > 1 ? "s" : ""} ?

        </Typography>

      </DialogContent>

      <DialogActions>

        <Button
          onClick={onClose}
          variant="outlined"
        >
          Cancel
        </Button>

        <Button
          color="error"
          variant="contained"
          onClick={onDelete}
        >
          Delete
        </Button>

      </DialogActions>
    </Dialog>
  );
};

export default DeleteInventoryDialog;